import React from 'react';
import ReactDOM from 'react-dom';
import './App.css';
import App from './App.js';
import './styles/Responsive.css'

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
